module.exports = __webpack_public_path__ + "img/eliza4.74d77abc.png";